export default class Card {

    constructor(el) {
        this.el = el;
    }

}